import mobileCarousel from '../utils/mobileCarousel';

mobileCarousel('swap-cards__top', '', 1.2, 0, false);

const topCards = document.querySelectorAll('.swap-cards__top-card');
const bottomContents = document.querySelectorAll('.swap-cards__bottom-content');
const bottomPersons = document.querySelectorAll('.swap-cards__bottom-persons');

if (topCards && topCards.length > 0) {
    const resetTopCards = () => {
        topCards.forEach(card => card.classList.remove('active'));
        bottomContents.forEach(content => content.classList.remove('active'));
    };

    topCards.forEach((topCard, key) => {
        topCard.addEventListener('click', e => {
            if (!topCard.classList.contains('active')) {
                resetTopCards();
                topCard.classList.add('active');
                bottomContents[key].classList.add('active');
            }
        });
    });
}

if (bottomPersons && bottomPersons.length > 0) {
    const handleButtonClick = (e, currentPage, maxPages, personCards) => {
        const startIndex = (currentPage - 1) * 4;
        const endIndex = startIndex + 4;
        const elementsToShow = Array.from(personCards).slice(
            startIndex,
            endIndex
        );

        elementsToShow.forEach(el => el.classList.remove('d-none'));

        if (currentPage === maxPages) {
            const { target } = e;
            target.classList.add('d-none');
        }
    };

    bottomPersons.forEach(persons => {
        const personCards = persons.querySelectorAll(
            '.swap-cards__bottom-person'
        );
        const cardsLength = personCards.length;
        const button = persons.querySelector(
            '.swap-cards__bottom-persons-button'
        );
        const maxPages = button
            ? parseInt(button.getAttribute('data-max-pages'))
            : null;
        let currentPage = 1;

        const handleButtonFunctionality = () => {
            if (window.innerWidth < 991.98) {
                button.addEventListener('click', e => {
                    currentPage++;
                    handleButtonClick(e, currentPage, maxPages, personCards);
                });
            }
        };

        if (button) {
            window.addEventListener('resize', handleButtonFunctionality);
            handleButtonFunctionality();
        }
    });
}
